import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { formatMoney, statusColors } from './userActivityTypes.utils';

type OrderDraftedProps = {
  entry: UserAuditLogEntry<'COMMERCE_ORDER_DRAFTED'>;
};

export const OrderDrafted = ({ entry }: OrderDraftedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="file-draft"
    color={statusColors.neutral}
    title="Order drafted"
    summary={
      <SummaryItems
        items={[
          { key: 'order', content: entry.order_id, copyText: entry.order_id },
          { key: 'total', content: formatMoney(entry.total) },
          { key: 'note', content: entry.note },
        ]}
      />
    }
  >
    {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
  </UserActivityCard>
);
